import React, { useCallback } from "react";
import { Button, message } from "antd";
import { connect } from "dva";
import { redirectToLogin } from "@/utils/route";
import { logout } from "@/utils/session";
const BoxHeader = ({ showLogoutButton = false, currentUser, loadingLogout, dispatch, children }) => {
    const handleLogout = useCallback(async () => {
        const hide = message.loading("Signing out...");
        const logoutResponse = await logout(currentUser?.email);
        hide();
        if ("error" in logoutResponse) {
            message.error("An error occurred while signing out");
            return;
        }
        dispatch({ type: "user/removeCurrentProfile" });
        redirectToLogin(false);
    }, [currentUser?.email, dispatch]);
    return (React.createElement("div", { style: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
        } },
        children,
        showLogoutButton && (React.createElement(Button, { type: "link", style: { position: "absolute", top: 0, left: 0, color: "#595959" }, onClick: handleLogout, loading: loadingLogout }, "Logout"))));
};
export default connect(({ user, loading }) => ({
    currentUser: user.currentUser,
    loadingLogout: loading.effects["user/logout"],
}))(BoxHeader);
